import script from "./xiaolijiaoxvechangdikebiao.vue?vue&type=script&setup=true&lang=js"
export * from "./xiaolijiaoxvechangdikebiao.vue?vue&type=script&setup=true&lang=js"

import "./xiaolijiaoxvechangdikebiao.vue?vue&type=style&index=0&id=9a76cd3e&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a76cd3e"]])

export default __exports__